import Vue from 'vue'
import { Slider, SliderItem } from 'vue-easy-slider'

import AnChild from '@/components/AnChild'
import AnPagenation from '@/components/AnPagenation'


Vue.component('an-child',AnChild)
Vue.component('an-pagenation',AnPagenation)
Vue.component('Slider',Slider)
Vue.component('slider-item',SliderItem)
